import CSVDownload from '@/components/common/download-csv'

const csvMixin = {
  components: {
    'm-csv-btn': CSVDownload
  },
  data () {
    return {
      csvItems: []
    }
  },
  methods: {
    createCSV (items) {
      var app = this;
      this.csvItems = JSON.parse(JSON.stringify(items));

      this.csvItems.forEach(item => {
        Object.keys(item).forEach(k => {
          if ((item[k] === 'null' || item[k] === null)) {
            item[k] = '';
          }
        });

        item.date = app.$options.filters.date(item.date);
        delete item.status;
        delete item.factuur;
      });
      console.log('createCSV', this.csvItems);
    }
  }
}
export default csvMixin
